module.exports = __webpack_public_path__ + "static/media/youtube.05fb326f.svg";